import { AgGridTable } from 'components/AgGrid/AgGridTable';
import type { WorkOrderChangeObjectItem, WorkOrderObjectData } from 'gql/graphql';

import type { AgGridReact } from 'ag-grid-react';
import type { RefObject } from 'react';

import Styles from '../WorkOrderUseCoefficient.module.css';

import { useSelectingObjectColumns } from './hooks/useSelectingObjectColumns';
import { useSelectingObjectDataGrid } from './hooks/useSelectingObjectDataGrid';

export interface GridDataRow extends Partial<WorkOrderObjectData> {
    level: number;
}

export const GridSelectingObject = (props: {
    isShowTable: boolean;
    checkedObjects: { [key: number]: boolean | 'intermediate' };
    onChangeCheckedObjects: (value: { [key: number]: boolean }) => void;
    currentDataItems?: (WorkOrderObjectData | WorkOrderChangeObjectItem)[] | null;
    comboxId?: number;
    constructionTypeId?: number;
    gridRef: RefObject<AgGridReact<any>>;
}) => {
    const {
        isShowTable,
        checkedObjects,
        onChangeCheckedObjects,
        comboxId,
        gridRef,
        currentDataItems,
        constructionTypeId,
    } = props;

    const gridDataRow = useSelectingObjectDataGrid({ currentDataItems, comboxId, constructionTypeId });

    const { columns } = useSelectingObjectColumns({ checkedObjects, onChangeCheckedObjects });

    const gridOptions = {
        headerHeight: 40,
        suppressRowHoverHighlight: true,
    };

    return (
        <div className="ag-theme-alpine GridSelectingObject">
            {isShowTable ? (
                <AgGridTable
                    gridOptions={gridOptions}
                    rowData={gridDataRow}
                    columnDefs={columns}
                    containerStyle={{ height: 322 }}
                    ref={gridRef}
                />
            ) : (
                <div className={Styles.CustomOverlay}>Для отображения данных выберите объект строительства</div>
            )}
        </div>
    );
};

GridSelectingObject.displayName = 'GridSelectingObject';
